<template>
  <section>
    <Header :state="state"></Header>
    <div class="content_wrap">
      <div class="wrap_img">
        <div class="wrap_item" @click="handleItem(item,index)" :class="[index%2==0?'left':'right']" v-for="(item,index) in data" :key="index">
          <div class="item_left">
            <p class="p_one">{{item.name}}</p>
            <p class="p_two">{{item.dateTime}}</p>
          </div>
          <div class="item_right ">付费阅读{{item.payCount}}元/条</div>
        </div>
      </div>
      <div class="more_wrap">更多资讯，敬请期待</div>
    </div>
    <el-dialog title="" :close-on-click-modal="false" :visible.sync="imgVisible" class="dialog_img">
      <img style="width:250px;" src="/static/images/pay.jpg" alt="">
      <!-- <el-row></el-row> -->
    </el-dialog>
    <Footer></Footer>
  </section>
</template>
<script>
import Header from '../components/common/header'
import Footer from '../components/common/footer'
export default {
  name: 'home',
  components: { Header,Footer },
  data () {
    const self = this;
    return {
      state:2,
      imgVisible:false,
      amap:'',
      data:[
        {name:'企业有限空间作业的正确操作方式',dateTime:'2020-07-06',payCount:'0.1'},
        {name:'应对强降雨引发的次生灾害，这些只是要掌握！',dateTime:'2020-06-23',payCount:'0.1'},
        {name:'警惕，这些安全隐患就在身边',dateTime:'2020-06-28',payCount:'0.1'},
        {name:'机械事故预防铁律“十二条”',dateTime:'2020-04-30',payCount:'0.1'},
        {name:'一图读懂冒顶事故应急处理',dateTime:'2020-04-24',payCount:'0.1'},
        {name:'车里这些东西看着使用，安全隐患却不小',dateTime:'2020-04-24',payCount:'0.1'}
      ]
    }
  },
  mounted(){
  },
  created(){
    
  },
  methods:{
    handleItem (item,index) {
      this.imgVisible = true
    }
  }
}
</script>
<style lang="less" scoped>
.content_wrap{
  padding: 0.5rem 0 0.7rem;
  .wrap_img{
    width: 80%;
    height: 4rem;
    margin: 0 auto;
    .wrap_item{
      width: 45%;
      margin-bottom: 0.2rem;
      display: inline-block;
      height: 1.2rem;
      padding: 0 2%;
      cursor: pointer;
      border: 0.01rem solid #ccc;
      .item_left{
        width: 70%;
        float: left;
        text-align: left;
        color: #333333;
        border-top: 0.01rem solid transparent;
        .p_one{
          margin-top: 0.2rem;
          font-weight: 600;
          line-height: 0.48rem;
          font-size: 0.24rem;
          overflow:hidden;
          white-space:nowrap;
          text-overflow:ellipsis;
        }
        .p_two{
          font-size: 0.16rem;
          line-height: 0.24rem;
        }
      }
      .item_right{
        width: 30%;
        float: left;
        color: red;
        text-align: right;
        line-height: 1.2rem;
        font-size: 0.18rem;
      }
    }
    .wrap_item.left{
      float: left;
    }
    .wrap_item.right{
      float: right;
    }
  }
}
.more_wrap{
  line-height: 0.3rem;
  font-size: 0.16rem;
  color: #333;
  text-align: center;
  padding: 1.2rem 0 0.3rem;
}
@media screen and(min-width: 1680px){
  .content_wrap{
    padding: 50px 0 70px;
    .wrap_img{
      width: 80%;
      height: 400px;
      margin: 0 auto;
      .wrap_item{
        width: 45%;
        margin-bottom: 20px;
        display: inline-block;
        height: 120px;
        padding: 0 2%;
        cursor: pointer;
        border: 1px solid #ccc;
        .item_left{
          width: 70%;
          float: left;
          text-align: left;
          color: #333333;
          border-top: 1px solid transparent;
          .p_one{
            margin-top: 20px;
            font-weight: 600;
            line-height: 48px;
            font-size: 24px;
            overflow:hidden;
            white-space:nowrap;
            text-overflow:ellipsis;
          }
          .p_two{
            font-size: 16px;
            line-height: 24px;
          }
        }
        .item_right{
          width: 30%;
          float: left;
          color: red;
          text-align: right;
          line-height: 120px;
          font-size: 18px;
        }
      }
      .wrap_item.left{
        float: left;
      }
      .wrap_item.right{
        float: right;
      }
    }
  }
  .more_wrap{
    line-height: 30px;
    font-size: 16px;
    color: #333;
    text-align: center;
    padding: 120px 0 30px;
  }
}
</style>
<style lang="less">
.dialog_img{
  .el-dialog{
    padding-bottom: 0.4rem !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/counselPaid.vue